import { Accessor, Setter, createContext, useContext } from "solid-js";
import { Post, PostTopic } from "../types/post";

interface Context {
	posts: Accessor<Post[]>;
	topics: Accessor<PostTopic[]>;
	topic: Accessor<string | undefined>;
	page: Accessor<number>;
	selected: Accessor<Post | undefined>;
	status: Accessor<"idle" | "loading">;
	pageCount: Accessor<number>;
	search: Accessor<string>;
	isSelected: Accessor<boolean>;

	setSearch: Setter<string>;
	setTopic: Setter<string | undefined>;
	setPage: Setter<number>;
	select: (id: string) => void;
	unselect: () => void;

}

export const PostsContext = createContext<Context>();

export function usePostsContext() {
	const ctx = useContext(PostsContext);
	if (!ctx) throw new Error('usePostsContext must be used within a PostsProvider');
	return ctx;
}